import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  ref,
  onMounted,
  onBeforeUnmount,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClickWrapper',
  emits: [
  'outside',
  'inside',
],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const root = ref<InstanceType<typeof HTMLElement>>();

const checkIfClickedOutside = (event: Event) => {
  let withinBoundaries = false;
  if (root.value) {
    withinBoundaries = event.composedPath()
      .includes(root.value);
  }

  if (!withinBoundaries) {
    emit('outside');
  } else {
    emit('inside');
  }
};

onMounted(() => {
  window.addEventListener('click', checkIfClickedOutside);
});

onBeforeUnmount(() => {
  window.addEventListener('click', checkIfClickedOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})